import React from 'react';
import styles from 'containers/Layouts/Layout.module.css';
import { useNavigate } from 'react-router-dom';
import ConfigurationService from 'services/ConfigurationService';
import i18n from 'i18n/I18nInstance';
import _ from 'classnames';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ActionButtons from './ActionButtons';
import IconButton from '@mui/material/IconButton';

interface IProps {
    goBackText?: string;
    actionsButtonsDownloadHandler?: (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
    actionsButtonsPrintHandler?: (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
    showActionButtons?: boolean;
    isFake?: boolean;
    documentTitle?: string;
}

export default function DocumentNavigation(props: IProps) {
    const navigate = useNavigate();
    const i18n_goBack = i18n.translator.formatMessage({
        id: 'documentNavigation.PreviousText',
        defaultMessage: 'Return to the Resources Page.',
    });
    const configuration = ConfigurationService.retrieveSessionConfiguration();

    return (
        <React.Fragment>
            <div data-qaid="goBack" className={_(styles.noPrint, styles.goBackContainer)}>
                <IconButton
                    onClick={() => navigate(-1)}
                    className={styles.goBackIconWrapper}
                    focusRipple={false}
                    aria-label={i18n_goBack}
                >
                    <ArrowBackIosIcon
                        fontSize="small"
                        className={styles.goBackIcon}
                        data-qaid="goBackIcon"
                    />

                    <div
                        data-qaid="goBackText"
                        className={_(styles.textForImage, styles.imageWithText)}
                    >
                        {props.goBackText}
                    </div>
                </IconButton>

                {configuration && !configuration.disablePrint && (
                    <ActionButtons
                        downloadHandler={props.actionsButtonsDownloadHandler}
                        printHandler={props.actionsButtonsPrintHandler}
                        showActionButtons={props.showActionButtons}
                        title={props.documentTitle}
                    />
                )}
            </div>
        </React.Fragment>
    );
}

DocumentNavigation.defaultProps = {
    showActionButtons: true,
};
